import React from "react";
import { compose, withAppContext, withActions } from "containers/HOC";
import * as utils from "common/utils";
import { useModal } from "common/effects";
import ActionLink from "components/ActionLink";
import { fetchFarm } from "containers/Farm/_actions";
import UpdateSmapSoilsModal from "./Modals/UpdateSmapSoilsModal";

const AnalysesPanelActions = ({ online, farm, createAnalysis, uploadAnalysis, restoreAnalysis }) => {
    const { openModal, getModal } = useModal();

    const _checkForSmapSoilUpdates = () => {
        const viewModel = {
            farm,
        };
        openModal("UpdateSmapSoilsModal", viewModel);
    };
    const updateSmapSoilsModal = getModal("UpdateSmapSoilsModal");

    const hasFarmWriteAccess = utils.canManageAnalyses(farm);
    const hasEditableBudgets = (farm.offlineBudgets || []).some((ob) => utils.canEditBudget(ob.budget));
    const hasPublications = farm.publications && farm.publications.length > 0;
    const showCheckSoils = online && (hasEditableBudgets || hasPublications);

    return (
        <>
            <div className="ActionsBar ActionsBar--super u-print-none">
                <div className="ActionsBar-left">
                    <ul className="ActionsBar-links">
                        {online && hasFarmWriteAccess && (
                            <li>
                                <ActionLink id="farm-home-create-budget" className="IconLink--arrow-plus" onClick={createAnalysis(farm)}>
                                    Create new analysis
                                </ActionLink>
                            </li>
                        )}
                        {online && hasFarmWriteAccess && (
                            <li>
                                <ActionLink id="farm-home-upload-budget" className="IconLink--upload" onClick={uploadAnalysis(farm)}>
                                    Upload analysis
                                </ActionLink>
                            </li>
                        )}
                        {online && hasFarmWriteAccess && (
                            <li>
                                <ActionLink id="restore-budgets" className="IconLink--history" onClick={restoreAnalysis(farm)}>
                                    Restore deleted year end analysis
                                </ActionLink>
                            </li>
                        )}
                    </ul>
                </div>
                <div className="ActionsBar-right">
                    {showCheckSoils && (
                        <ul className="ActionsBar-links">
                            <li>
                                <ActionLink id="check-soils" className="IconLink--sync" onClick={_checkForSmapSoilUpdates}>
                                    Check for S-Map soil updates
                                </ActionLink>
                            </li>
                        </ul>
                    )}
                </div>
            </div>
            {updateSmapSoilsModal && <UpdateSmapSoilsModal {...updateSmapSoilsModal.modalProps} />}
        </>
    );
};

export default compose(withAppContext, withActions({ fetchFarm }))(AnalysesPanelActions);
